import React from "react";
import { Create, translate } from "react-admin";
import ServiceForm from "./ServiceForm";

const ServiceTitle = ({ translate }) => {
  return <span>{`สร้าง${translate("service.service")}`}</span>;
};

const Title = translate(ServiceTitle);

export const ServiceCreate = props => (
  <Create title={<Title />} {...props}>
    <ServiceForm />
  </Create>
);



// WEBPACK FOOTER //
// ./src/components/service/ServiceCreate.js